import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getAttendeesQuery($eventId: ID!) {
    attendees(eventId: $eventId) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          fullName
          email
          phone
          additionalGuests
          status
          crmUrl
          isResident
          attended
          rsvpCancelReason
        }
      }
    }
  }
`;
